(function () {
  'use strict';

  var configuratorRoot = document.querySelector('[data-custom-chopstick-configurator-root]');
  if (!configuratorRoot || configuratorRoot.configuratorDesignDocuments || !configuratorRoot.configuratorLayouts) return;

  var layouts = configuratorRoot.configuratorLayouts;
  var DOCUMENT_VERSION = 3;
  var MAX_OBJECTS_PER_SIDE = 50;
  var MAX_DESIGN_IMAGES = 6;
  var MAX_DELETED_OBJECTS = 100;
  var SEMANTIC_TEXT_REFERENCES = [
    'restaurantName',
    'restaurantInfo',
    'restaurantInfo.address',
    'restaurantInfo.phone',
    'restaurantInfo.contact',
    'message',
    'additionalText'
  ];
  var SEMANTIC_PLACEHOLDERS = {
    restaurantName: 'Restaurant name',
    restaurantInfo: 'Restaurant information',
    'restaurantInfo.address': 'Address',
    'restaurantInfo.phone': 'Phone',
    'restaurantInfo.contact': 'Website or contact',
    message: 'Message or instructions',
    additionalText: 'Additional text'
  };

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
  }

  function isFiniteNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
  }

  function hashString(value) {
    var hash = 2166136261;
    for (var index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return ('00000000' + (hash >>> 0).toString(16)).slice(-8);
  }

  function enabledModules(configuration) {
    var enabled = configuration && configuration.content && Array.isArray(configuration.content.enabledTypes)
      ? configuration.content.enabledTypes
      : [];
    return layouts.moduleOrder.filter(function (moduleId) { return enabled.indexOf(moduleId) !== -1; });
  }

  function getStructureFingerprint(configuration) {
    return structureFingerprintForModules(enabledModules(configuration));
  }

  function structureFingerprintForModules(modules) {
    var ordered = layouts.moduleOrder.filter(function (moduleId) { return modules.indexOf(moduleId) !== -1; });
    return 'design-structure-v1-' + hashString(JSON.stringify(ordered));
  }

  function normalizeFrame(rectangle) {
    return {
      x: rectangle.x / layouts.artworkSize.width,
      y: rectangle.y / layouts.artworkSize.height,
      width: rectangle.width / layouts.artworkSize.width,
      height: rectangle.height / layouts.artworkSize.height
    };
  }

  function roleStyle(role, rectangle) {
    var maximumSize = role === 'title' ? 42 : role === 'message' ? 30 : 24;
    var fontFamily = role === 'title' || role === 'message' ? 'Georgia, serif' : 'Arial, sans-serif';
    var fontWeight = role === 'title' ? 700 : role === 'additional' ? 600 : role === 'message' ? 400 : 500;
    return {
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontStyle: role === 'message' ? 'italic' : 'normal',
      fontSize: Math.min(maximumSize, rectangle.height * .72) / layouts.artworkSize.height,
      lineHeight: 1.16,
      fill: '#000000',
      align: 'center',
      fit: 'shrink',
      paddingX: 6 / layouts.artworkSize.width,
      paddingY: 2 / layouts.artworkSize.height
    };
  }

  function createObject(block, side, rectangle) {
    var objectId = 'object-' + side + '-' + block.id;
    var frame = normalizeFrame(rectangle);
    if (block.kind === 'logo') {
      return {
        id: objectId,
        type: 'image',
        role: block.role,
        frame: frame,
        rotation: 0,
        assetRef: { kind: 'semantic', reference: 'logo' },
        style: { fit: 'contain', align: 'center', padding: .08, opacity: 1 }
      };
    }
    return {
      id: objectId,
      type: 'text',
      role: block.role,
      frame: frame,
      rotation: 0,
      content: { kind: 'semantic', reference: block.module },
      style: roleStyle(block.role, rectangle)
    };
  }

  function createSide(sideId, sourceSide) {
    var rectangles = layouts.getBlockRectangles(sourceSide);
    var objects = sourceSide.blocks.map(function (block, index) {
      var object = createObject(block, sideId, rectangles[index]);
      object.style.align = sourceSide.alignment;
      return object;
    });
    return {
      background: { fill: '#f7f4ed' },
      objects: objects
    };
  }

  function createDocumentId(sourceId, sourceVersion, structureFingerprint) {
    return 'design-' + hashString(sourceId + '|' + sourceVersion + '|' + structureFingerprint);
  }

  function createDocument(definition) {
    if (!isPlainObject(definition) || !isPlainObject(definition.provenance) || !isPlainObject(definition.sides)) return null;
    var document = {
      version: DOCUMENT_VERSION,
      id: '',
      coordinateSpace: 'normalized',
      structureFingerprint: '',
      provenance: clone(definition.provenance),
      deletedObjects: [],
      sides: clone(definition.sides)
    };
    document.structureFingerprint = structureFingerprintForModules(boundModules(document));
    document.id = createDocumentId(
      document.provenance.sourceId,
      document.provenance.sourceVersion,
      document.structureFingerprint
    );
    return isDocumentStructure(document) ? document : null;
  }

  function fromComposition(composition, configuration) {
    if (!layouts.validateComposition(composition, configuration)) return null;
    return createDocument({
      provenance: {
        kind: 'generated-layout',
        sourceId: composition.layoutId,
        sourceVersion: composition.version
      },
      sides: {
        front: createSide('front', composition.sides.front),
        back: createSide('back', composition.sides.back)
      }
    });
  }

  function safeAreaFrame() {
    return normalizeFrame(layouts.safeArea);
  }

  function createWorkingDocument(configuration) {
    var logoEnabled = enabledModules(configuration).indexOf('logo') !== -1 && Boolean(configuration.logo);
    var frontObjects = [];
    if (logoEnabled) {
      frontObjects.push({
        id: 'object-front-working-logo',
        type: 'image',
        role: 'brand',
        frame: safeAreaFrame(),
        rotation: 0,
        assetRef: { kind: 'semantic', reference: 'logo' },
        style: { fit: 'contain', align: 'center', padding: .08, opacity: 1 }
      });
    }
    return createDocument({
      provenance: { kind: 'working-preview', sourceId: 'working-preview', sourceVersion: 1 },
      sides: {
        front: { background: { fill: '#f7f4ed' }, objects: frontObjects },
        back: { background: { fill: '#f7f4ed' }, objects: [] }
      }
    });
  }

  function validFrame(frame) {
    if (!isPlainObject(frame)) return false;
    if (![frame.x, frame.y, frame.width, frame.height].every(isFiniteNumber)) return false;
    return Math.abs(frame.x) <= 100 && Math.abs(frame.y) <= 100 &&
      frame.width > 0 && frame.width <= 100 && frame.height > 0 && frame.height <= 100;
  }

  function validBaseObject(object) {
    return Boolean(
      isPlainObject(object) &&
      typeof object.id === 'string' && object.id.length > 0 && object.id.length <= 180 &&
      typeof object.role === 'string' && object.role.length > 0 && object.role.length <= 80 &&
      validFrame(object.frame) &&
      isFiniteNumber(object.rotation) && Math.abs(object.rotation) <= 360 &&
      isPlainObject(object.style)
    );
  }

  function validTextStyle(style) {
    return Boolean(
      typeof style.fontFamily === 'string' && style.fontFamily.length > 0 && style.fontFamily.length <= 160 &&
      isFiniteNumber(style.fontWeight) && style.fontWeight >= 100 && style.fontWeight <= 900 &&
      (style.fontStyle === 'normal' || style.fontStyle === 'italic') &&
      isFiniteNumber(style.fontSize) && style.fontSize > 0 && style.fontSize <= 10 &&
      isFiniteNumber(style.lineHeight) && style.lineHeight >= .5 && style.lineHeight <= 3 &&
      typeof style.fill === 'string' && style.fill.length > 0 && style.fill.length <= 80 &&
      ['left', 'center', 'right'].indexOf(style.align) !== -1 &&
      (style.fit === 'shrink' || style.fit === 'fixed') &&
      isFiniteNumber(style.paddingX) && style.paddingX >= 0 && style.paddingX <= .25 &&
      isFiniteNumber(style.paddingY) && style.paddingY >= 0 && style.paddingY <= .25 &&
      (style.letterSpacing === undefined || (isFiniteNumber(style.letterSpacing) && Math.abs(style.letterSpacing) <= .25)) &&
      (style.wrap === undefined || style.wrap === 'word' || style.wrap === 'none') &&
      (style.autoGrow === undefined || typeof style.autoGrow === 'boolean')
    );
  }

  function validImageStyle(style) {
    return Boolean(
      (style.fit === 'contain' || style.fit === 'cover' || style.fit === 'fill') &&
      ['left', 'center', 'right'].indexOf(style.align) !== -1 &&
      isFiniteNumber(style.padding) && style.padding >= 0 && style.padding <= .45 &&
      isFiniteNumber(style.opacity) && style.opacity >= 0 && style.opacity <= 1 &&
      (style.contentFrame === undefined || (
        isPlainObject(style.contentFrame) &&
        [style.contentFrame.x, style.contentFrame.y, style.contentFrame.width, style.contentFrame.height].every(isFiniteNumber) &&
        Math.abs(style.contentFrame.x) <= 100 && Math.abs(style.contentFrame.y) <= 100 &&
        style.contentFrame.width > 0 && style.contentFrame.width <= 100 &&
        style.contentFrame.height > 0 && style.contentFrame.height <= 100
      ))
    );
  }

  function validObject(object) {
    if (!validBaseObject(object)) return false;
    if (object.type === 'text') {
      if (!isPlainObject(object.content) || !validTextStyle(object.style)) return false;
      if (object.content.kind === 'semantic') {
        return SEMANTIC_TEXT_REFERENCES.indexOf(object.content.reference) !== -1;
      }
      return object.content.kind === 'literal' &&
        typeof object.content.value === 'string' && object.content.value.length <= 2000;
    }
    if (object.type === 'image') {
      if (!isPlainObject(object.assetRef) || !validImageStyle(object.style)) return false;
      if (object.assetRef.kind === 'semantic') return object.assetRef.reference === 'logo';
      if (object.assetRef.kind === 'template') {
        return typeof object.assetRef.templateId === 'string' && object.assetRef.templateId.length > 0 && object.assetRef.templateId.length <= 180 &&
          typeof object.assetRef.sourceId === 'string' && object.assetRef.sourceId.length > 0 && object.assetRef.sourceId.length <= 80 &&
          Array.isArray(object.assetRef.crop) && object.assetRef.crop.length === 4 && object.assetRef.crop.every(function (value) {
            return isFiniteNumber(value) && value >= 0;
          });
      }
      return object.assetRef.kind === 'design' &&
        typeof object.assetRef.assetId === 'string' &&
        object.assetRef.assetId.length > 0 && object.assetRef.assetId.length <= 180;
    }
    return false;
  }

  function validSide(side) {
    return Boolean(
      isPlainObject(side) &&
      isPlainObject(side.background) &&
      typeof side.background.fill === 'string' && side.background.fill.length > 0 && side.background.fill.length <= 80 &&
      Array.isArray(side.objects) && side.objects.length <= MAX_OBJECTS_PER_SIDE &&
      side.objects.every(validObject)
    );
  }

  function normalizePrintColor(value) {
    if (typeof value !== 'string') return null;
    var color = value.trim().toLowerCase();
    var shortHex = /^#([0-9a-f]{3})$/.exec(color);
    if (shortHex) color = '#' + shortHex[1].split('').map(function (part) { return part + part; }).join('');
    if (!/^#[0-9a-f]{6}$/.test(color)) return color;
    return color === '#ffffff' ? null : color;
  }

  function knownPrintColors(document) {
    var colors = [];
    if (!document || !document.sides) return colors;
    ['front', 'back'].forEach(function (sideId) {
      var side = document.sides[sideId];
      var background = side && side.background && normalizePrintColor(side.background.fill);
      if (background && colors.indexOf(background) === -1) colors.push(background);
      (side && side.objects || []).forEach(function (object) {
        var fill = object.type === 'text' && object.style && normalizePrintColor(object.style.fill);
        if (fill && colors.indexOf(fill) === -1) colors.push(fill);
      });
    });
    return colors;
  }

  function isDocumentStructure(document, skipColorLimit) {
    if (!isPlainObject(document) || document.version !== DOCUMENT_VERSION || document.coordinateSpace !== 'normalized') return false;
    if (typeof document.id !== 'string' || !document.id || document.id.length > 180) return false;
    if (typeof document.structureFingerprint !== 'string' || !document.structureFingerprint || document.structureFingerprint.length > 180) return false;
    if (!isPlainObject(document.provenance)) return false;
    if (['generated-layout', 'working-preview', 'personalized-recipe', 'professional-template', 'create-my-own'].indexOf(document.provenance.kind) === -1) return false;
    if (typeof document.provenance.sourceId !== 'string' || !document.provenance.sourceId || document.provenance.sourceId.length > 180) return false;
    if (!Number.isInteger(document.provenance.sourceVersion) || document.provenance.sourceVersion < 1) return false;
    if (!isPlainObject(document.sides) || !validSide(document.sides.front) || !validSide(document.sides.back)) return false;
    if (document.deletedObjects !== undefined && (
      !Array.isArray(document.deletedObjects) ||
      document.deletedObjects.length > MAX_DELETED_OBJECTS ||
      !document.deletedObjects.every(function (entry) {
        return isPlainObject(entry) &&
          typeof entry.id === 'string' && entry.id.length > 0 && entry.id.length <= 180 &&
          layouts.moduleOrder.indexOf(entry.module) !== -1;
      })
    )) return false;

    var designImageCount = document.sides.front.objects.concat(document.sides.back.objects).filter(function (object) {
      return object.type === 'image' && object.assetRef.kind === 'design';
    }).length;
    if (designImageCount > MAX_DESIGN_IMAGES || (!skipColorLimit && knownPrintColors(document).length > 2)) return false;

    var objectIds = {};
    var objectsValid = document.sides.front.objects.concat(document.sides.back.objects).every(function (object) {
      if (objectIds[object.id]) return false;
      objectIds[object.id] = true;
      return true;
    });
    if (!objectsValid) return false;
    var deletedIds = {};
    return (document.deletedObjects || []).every(function (entry) {
      if (objectIds[entry.id] || deletedIds[entry.id]) return false;
      deletedIds[entry.id] = true;
      return true;
    });
  }

  function migrateDocument(document) {
    if (!isPlainObject(document)) return null;
    if (document.version === DOCUMENT_VERSION) return isDocumentStructure(document) ? clone(document) : null;
    if (document.version !== 1 && document.version !== 2) return null;
    var migrated = clone(document);
    migrated.version = DOCUMENT_VERSION;
    return isDocumentStructure(migrated, true) ? migrated : null;
  }

  function moduleForObject(object) {
    if (!isPlainObject(object)) return null;
    if (object.type === 'image') {
      return isPlainObject(object.assetRef) && object.assetRef.kind === 'semantic' && object.assetRef.reference === 'logo' ? 'logo' : null;
    }
    if (!isPlainObject(object.content) || object.content.kind !== 'semantic') return null;
    return object.content.reference.indexOf('restaurantInfo') === 0 ? 'restaurantInfo' : object.content.reference;
  }

  function boundModules(document) {
    var represented = [];
    var frontObjects = document && document.sides && document.sides.front && Array.isArray(document.sides.front.objects)
      ? document.sides.front.objects
      : [];
    var backObjects = document && document.sides && document.sides.back && Array.isArray(document.sides.back.objects)
      ? document.sides.back.objects
      : [];
    frontObjects.concat(backObjects).forEach(function (object) {
      var moduleId = moduleForObject(object);
      if (moduleId && represented.indexOf(moduleId) === -1) represented.push(moduleId);
    });
    return layouts.moduleOrder.filter(function (moduleId) { return represented.indexOf(moduleId) !== -1; });
  }

  function representedModules(document) {
    var represented = boundModules(document);
    (document && document.deletedObjects || []).forEach(function (entry) {
      if (represented.indexOf(entry.module) === -1) represented.push(entry.module);
    });
    return layouts.moduleOrder.filter(function (moduleId) { return represented.indexOf(moduleId) !== -1; });
  }

  function refreshDocumentIdentity(document) {
    document.structureFingerprint = structureFingerprintForModules(representedModules(document));
    document.id = createDocumentId(
      document.provenance.sourceId,
      document.provenance.sourceVersion,
      document.structureFingerprint
    );
    return document;
  }

  function deleteObjects(document, objectIds) {
    if (!isDocumentStructure(document) || !Array.isArray(objectIds) || !objectIds.length) return null;
    var next = clone(document);
    if (!Array.isArray(next.deletedObjects)) next.deletedObjects = [];
    ['front', 'back'].forEach(function (side) {
      next.sides[side].objects = next.sides[side].objects.filter(function (object) {
        if (objectIds.indexOf(object.id) === -1) return true;
        var moduleId = moduleForObject(object);
        if (moduleId && !next.deletedObjects.some(function (entry) { return entry.id === object.id; })) {
          next.deletedObjects.push({ id: object.id, module: moduleId });
        }
        return false;
      });
    });
    refreshDocumentIdentity(next);
    return isDocumentStructure(next) ? next : null;
  }

  function carryDeletedObjects(source, target) {
    if (!isDocumentStructure(source) || !isDocumentStructure(target) || !source.deletedObjects || !source.deletedObjects.length) {
      return clone(target);
    }
    var next = clone(target);
    next.deletedObjects = clone(source.deletedObjects);
    var deletedIds = next.deletedObjects.map(function (entry) { return entry.id; });
    ['front', 'back'].forEach(function (side) {
      next.sides[side].objects = next.sides[side].objects.filter(function (object) {
        return deletedIds.indexOf(object.id) === -1;
      });
    });
    refreshDocumentIdentity(next);
    return isDocumentStructure(next) ? next : clone(target);
  }

  function validateDocument(document, configuration) {
    if (!isDocumentStructure(document) || document.provenance.kind === 'working-preview') return false;
    var represented = representedModules(document);
    if (document.structureFingerprint !== structureFingerprintForModules(represented)) return false;
    if (document.provenance.kind === 'professional-template') return true;
    return enabledModules(configuration).every(function (moduleId) { return represented.indexOf(moduleId) !== -1; });
  }

  function resolveSemanticText(reference, configuration) {
    var values = configuration.content.values;
    if (reference === 'restaurantInfo') {
      return [values.restaurantInfo.address, values.restaurantInfo.phone, values.restaurantInfo.contact]
        .map(function (value) { return String(value || '').trim(); })
        .filter(Boolean)
        .join('  •  ');
    }
    if (reference.indexOf('restaurantInfo.') === 0) {
      return String(values.restaurantInfo[reference.split('.')[1]] || '').trim();
    }
    return String(values[reference] || '').trim();
  }

  function DesignDocumentError(code, message) {
    this.name = 'DesignDocumentError';
    this.code = code;
    this.message = message;
  }
  DesignDocumentError.prototype = Object.create(Error.prototype);
  DesignDocumentError.prototype.constructor = DesignDocumentError;

  function resolveObject(object, configuration, assets, options, moduleActive) {
    var resolved = {
      id: object.id,
      type: object.type,
      role: object.role,
      frame: clone(object.frame),
      rotation: object.rotation,
      style: clone(object.style)
    };
    if (object.type === 'text') {
      var semantic = object.content.kind === 'semantic';
      var semanticText = semantic
        ? resolveSemanticText(object.content.reference, configuration)
        : object.content.value;
      resolved.text = semanticText;
      if (semantic) {
        resolved.semanticReference = object.content.reference;
        resolved.sourceText = semanticText;
      }
      if (semantic && options.includePlaceholders && options.includeTextPlaceholders !== false && (!moduleActive || !semanticText)) {
        resolved.text = SEMANTIC_PLACEHOLDERS[object.content.reference] || 'Add content';
        resolved.placeholder = {
          state: moduleActive ? 'awaiting-content' : 'dormant',
          label: resolved.text
        };
      }
      if (semantic && options.includeTextPlaceholders === false && (!moduleActive || !semanticText)) return null;
      return resolved;
    }

    var assetRecord = null;
    var placeholderLabel = 'Add image';
    if (object.assetRef.kind === 'semantic') {
      var logoMetadata = configuration.logo;
      assetRecord = assets && assets.logo;
      if (!logoMetadata || !assetRecord || assetRecord.id !== logoMetadata.assetId || !assetRecord.blob) {
        assetRecord = null;
      }
      placeholderLabel = logoMetadata ? 'Replace logo' : 'Add logo';
      resolved.semanticReference = 'logo';
    } else if (object.assetRef.kind === 'design') {
      assetRecord = assets && assets.images && assets.images[object.assetRef.assetId];
      placeholderLabel = 'Replace image';
      resolved.assetRef = clone(object.assetRef);
    } else {
      assetRecord = assets && assets.templates && assets.templates[object.assetRef.templateId];
      placeholderLabel = 'Professional artwork unavailable';
      resolved.assetRef = clone(object.assetRef);
    }
    if (!assetRecord || !moduleActive) {
      if (!options.includePlaceholders) return null;
      resolved.placeholder = {
        state: !moduleActive ? 'dormant' : 'missing-asset',
        label: placeholderLabel
      };
      return resolved;
    }
    resolved.asset = {
      id: assetRecord.id,
      blob: assetRecord.blob,
      element: assetRecord.element,
      type: assetRecord.type,
      width: assetRecord.width,
      height: assetRecord.height
    };
    return resolved;
  }

  function resolveDocument(document, configuration, assets, options) {
    options = options || {};
    if (!isDocumentStructure(document)) throw new DesignDocumentError('invalid-document', 'The design document is invalid.');
    var active = enabledModules(configuration);
    var represented = representedModules(document);
    if (
      document.provenance.kind !== 'working-preview' && document.provenance.kind !== 'professional-template' &&
      !active.every(function (moduleId) { return represented.indexOf(moduleId) !== -1; })
    ) {
      throw new DesignDocumentError('missing-binding', 'The design does not represent all enabled content.');
    }
    function activeObjects(side) {
      return side.objects.filter(function (object) {
        var moduleId = moduleForObject(object);
        return options.includePlaceholders || moduleId === null || active.indexOf(moduleId) !== -1;
      }).map(function (object) {
        var moduleId = moduleForObject(object);
        return resolveObject(object, configuration, assets, options, moduleId === null || active.indexOf(moduleId) !== -1);
      }).filter(Boolean);
    }
    return {
      version: document.version,
      id: document.id,
      coordinateSpace: document.coordinateSpace,
      provenance: clone(document.provenance),
      sides: {
        front: {
          background: clone(document.sides.front.background),
          objects: activeObjects(document.sides.front)
        },
        back: {
          background: clone(document.sides.back.background),
          objects: activeObjects(document.sides.back)
        }
      }
    };
  }

  function reconcileDocument(document, previousConfiguration, nextConfiguration) {
    if (!document) return { document: null, status: 'empty' };
    if (!validateDocument(document, previousConfiguration)) return { document: null, status: 'invalidated' };
    if (document.provenance.kind === 'professional-template') {
      return { document: clone(document), status: 'preserved-value' };
    }
    var represented = representedModules(document);
    if (!enabledModules(nextConfiguration).every(function (moduleId) { return represented.indexOf(moduleId) !== -1; })) {
      return { document: null, status: 'invalidated-structure' };
    }
    var modulesChanged = JSON.stringify(enabledModules(previousConfiguration)) !== JSON.stringify(enabledModules(nextConfiguration));
    return { document: clone(document), status: modulesChanged ? 'preserved-dormancy' : 'preserved-value' };
  }

  configuratorRoot.configuratorDesignDocuments = {
    version: DOCUMENT_VERSION,
    getStructureFingerprint: getStructureFingerprint,
    createDocument: createDocument,
    fromComposition: fromComposition,
    migrateComposition: fromComposition,
    migrateDocument: migrateDocument,
    createWorkingDocument: createWorkingDocument,
    isDocumentStructure: isDocumentStructure,
    validateDocument: validateDocument,
    resolveDocument: resolveDocument,
    reconcileDocument: reconcileDocument,
    deleteObjects: deleteObjects,
    carryDeletedObjects: carryDeletedObjects,
    getKnownPrintColors: function (document) { return knownPrintColors(document).slice(); },
    getModuleForObject: function (object) {
      return moduleForObject(object);
    },
    boundModules: function (document) {
      return isDocumentStructure(document) ? boundModules(document) : [];
    }
  };
}());
